import React from "react"
type Props = {
  pageTitle: string
  desc: string
  className: string
}
const CenterHeroSection: React.FC<Props> = ({
  pageTitle,
  desc,
  className
}) => {
  return (
    <section
    className={`hero technology-herosection !h-auto !min-h-0	  ${className}`}>
      <div className="container lg:container md:mx-auto top-hero">
        <div className="flex hero-row gap-5 relative z-[1] h-full">
          <div className="lg:w-6/12 mx-auto text-center my-[5px]">
            <div className="inline-flex flex-col lg:items-start gap-6 hero-content justify-center h-full">
              <h1 className="mb-0 dark:text-textcolor">{pageTitle}</h1>
              <p className="mb-0 font-semibold text-secondary dark:text-secondary">{desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CenterHeroSection
